import { SendMailState, SendMailActionTypes, SET_SEND_MAIL_INITIAL_STATE, UPDATE_SEND_MAIL_STATE, SET_NEXT_KEY_PICKER_COMPONENT_CC, SET_NEXT_KEY_PICKER_COMPONENT_TO } from './types'

const intialSendMailFields = {
    from: {
        displayName: "Da",
        internalName: "from",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [],
        multi: false

    },
    to: {
        displayName: "A",
        internalName: "to",
        list: "Rubrica", ///Utilizzando "Rubrica" capisco che devo puntare alla rubrica arxeia
        sharepointType: "",
        controlType: "autocompleteContact",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false,
        multi: true,
    },
    cc: {
        displayName: "CC",
        internalName: "cc",
        list: "Rubrica", ///Utilizzando "Rubrica" capisco che devo puntare alla rubrica arxeia
        sharepointType: "",
        controlType: "autocompleteContact",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false,
        multi: true
    },
    subject: {
        displayName: "Oggetto",
        internalName: "subject",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    },
    body: {
        displayName: "Corpo",
        internalName: "body",
        sharepointType: "Text",
        controlType: "quill-editor",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    }
}

const initialState: SendMailState = {
    contactPanelIsOpen: false,
    targetFieldInternalNameOnAddContact: undefined,
    sendMailFields: { ...intialSendMailFields },
    pickerToKey: 0,
    pickerCcKey: 0


}

export function sendMailReducer(state = initialState, action: SendMailActionTypes): SendMailState {
    switch (action.type) {
        case SET_SEND_MAIL_INITIAL_STATE: {
            return {
                ...initialState,
                sendMailFields: {
                    from: { ...intialSendMailFields.from, internalValue: undefined },
                    to: { ...intialSendMailFields.to , internalValue: []},
                    cc: { ...intialSendMailFields.cc , internalValue: []},
                    subject: { ...intialSendMailFields.subject , internalValue: undefined},
                    body: { ...intialSendMailFields.body , internalValue: undefined},
                }
            }
        }

        case SET_NEXT_KEY_PICKER_COMPONENT_TO: {
            return {
                ...state,
                pickerToKey: state.pickerToKey + 1
            }
        }

        case SET_NEXT_KEY_PICKER_COMPONENT_CC: {
            return {
                ...state,
                pickerCcKey: state.pickerCcKey + 1
            }
        }

        case UPDATE_SEND_MAIL_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        default:
            return state
    }
}